import type { ChartCharacteristic } from '../../schema';
import { useTranslation } from '../../i18n';

export function ChartView({ characteristic }: { characteristic: ChartCharacteristic }) {
    const { t } = useTranslation();
    const label = characteristic.chartType
        ? t('chart.placeholder_with_type', { type: characteristic.chartType })
        : t('chart.placeholder');
    return (
        <div className="cfg-chart-placeholder" role="img" aria-label={label}>
            {label}
        </div>
    );
}
